import React from 'react';

const DeckModal = ({ mainDeck, onClose }) => {
  return (
    <div className="deck-modal-backdrop" >
      <div className="deck-modal" onMouseDown={(e) => e.stopPropagation()}>
        <h3>Your Deck ({mainDeck.length} cards)</h3>
        <div className="deck-gallery">
          {mainDeck.map((card, index) => (
            <img
              key={index}
              src={card.card_images[0].image_url}
              alt={card.name}
              className="deck-gallery-card"
            />
          ))}
        </div>
        <button onClick={onClose}>Close</button>
      </div>
    </div>
  );
};

export default DeckModal;
